import { Operation } from '../../../__generated__/globalTypes'

import {
  ItemCategoryFragment,
  itemCategoryFragmentString,
} from '../../fragments/__generated__/ItemCategoryFragment'

import { campaignFragmentString } from '../../fragments/__generated__/CampaignFragment'

import { itemFragmentString } from '../../fragments/__generated__/ItemFragment'

import { priceString } from '../../fragments/__generated__/Price'

import { sendDelayFragmentString } from '../../fragments/__generated__/SendDelayFragment'

import { minimalPanelFragmentString } from '../../fragments/__generated__/MinimalPanelFragment'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { campaignLineFragmentString } from '../../fragments/__generated__/CampaignLineFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import getItemCategoriesRawString from '../GetItemCategories.graphql'

const getItemCategoriesString = [
  getItemCategoriesRawString,
  itemCategoryFragmentString,
  campaignFragmentString,
  itemFragmentString,
  priceString,
  sendDelayFragmentString,
  minimalPanelFragmentString,
  giftVariationFragmentString,
  campaignLineFragmentString,
  amountString,
].join('\n\n')

export type GetItemCategoriesData = {
  itemCategories: (ItemCategoryFragment & {
    children: ItemCategoryFragment[]
  })[]
}

export type GetItemCategories = Operation<GetItemCategoriesData>

export const GetItemCategories = (): GetItemCategories => ({
  query: getItemCategoriesString,
  variables: undefined,
})
